import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CustomizedSnackbars = ({ show, withButton = false, onClose, message }) => {
  //const [open, setOpen] = useState(show);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose && onClose()

    //setOpen(false);
  };

  return (
    <div>
      {withButton && <Button onClick={() => {}}>Open Snackbar</Button>}
      <Snackbar open={show} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default CustomizedSnackbars;